import * as React from 'react'
import * as csm from './csm'
import { WatchlistAction, DVString, APIClient, safeBool, serializeFormdata } from 'DVWebNodeUtils';
import { WatchlistButton } from './nody1compatibilityPorts/Button';

const TRANSITION_LENGTH_MILLIS = 600

interface WatchlistActionsProps {
  watchlistAction: WatchlistAction
  addCallback: Function
  string: string,
  buttonTextClassName: string
}


interface WatchlistActionsState {
  buttonState: string
  ajaxEnabled: boolean
  isOnWatchlist: boolean
  endpointPartialURL: string
  endpointQuery: { [key: string]: string }
  isTransitioning: boolean
  hasMounted: boolean
  text: string
}

class WatchlistActions extends React.Component<WatchlistActionsProps, WatchlistActionsState> {
  state: WatchlistActionsState

  constructor(props: WatchlistActionsProps) {
    super(props)
    this.state = {
      isOnWatchlist: props.watchlistAction &&
        (props.watchlistAction.tag === 'Remove'),
      endpointPartialURL: props.watchlistAction &&
        props.watchlistAction.endpoint.partialURL,
      endpointQuery: props.watchlistAction && props.watchlistAction.endpoint &&
        props.watchlistAction.endpoint.query,
      isTransitioning: false,
      buttonState: props.watchlistAction &&
        (props.watchlistAction.tag === 'Remove') ? 'added' : 'add',
      hasMounted: false,
      ajaxEnabled: props.watchlistAction &&
        safeBool(props.watchlistAction.ajaxEnabled),
      text: props.watchlistAction && props.watchlistAction.text && props.watchlistAction.text &&
        (props.watchlistAction.text as DVString).string
    }
    this.sendToggleRequest = this.sendToggleRequest.bind(this)
  }

  sendAddToWatchlistCallback() {
    if (this.state.buttonState === 'add' && this.props.addCallback) {
      this.props.addCallback()
    }
  }


  sendToggleRequest = (evt: MouseEvent) => {
    evt.preventDefault()
    this.sendAddToWatchlistCallback()

    if (!this.state.ajaxEnabled) {
      const endpointQuery = Object.keys(this.state.endpointQuery).map((key) =>
        `${key}=${encodeURIComponent(this.state.endpointQuery[key])}`).join('&')
      window.location.href = `${this.state.endpointPartialURL}?${endpointQuery}`
      return
    }
    const api = new APIClient
    const
      query = this.state.endpointQuery,
      watchlistParams = serializeFormdata(query)
    api.call(this.state.endpointPartialURL, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-requested-with': 'XMLHttpRequest' // must be there for WPS not to do the redirect
      },
      body: watchlistParams
    }).then((json: { [key: string]: any }) => {
      const action = json.watchlistAction || false
      if (action && action.endpoint) {
        this.setState({
          endpointPartialURL: action.endpoint.partialURL,
          endpointQuery: action.endpoint.query,
          isTransitioning: true,
          isOnWatchlist: action.tag === 'Remove',
          buttonState: 'progress'
        })
        window.setTimeout(() => this.setState({
          ...this.state,
          isTransitioning: false,
          buttonState: action.tag === 'Remove' ? 'added' : 'add'
        }), TRANSITION_LENGTH_MILLIS)
      }
    }).catch((error: Error) => {
      csm.logError(`WatchlistAction Failed to get response from WPS: ${error.message}.`, error)
    })
  }


  componentDidMount() {
    this.setState({ ...this.state, hasMounted: true })
  }

  render() {
    const ariaLabel = this.state.text
    return (
      <WatchlistButton onClick={this.sendToggleRequest}
        status={this.state.buttonState}
        aria-label={ariaLabel}>
        <span className={this.props.buttonTextClassName}>{this.props.string}</span>
      </WatchlistButton>
    )
  }
}
export default WatchlistActions
